import React, { useMemo, useState } from "react";
import styles from '../styles/account.module.scss'
import { BankCardList, CardType, getWalletLocalConfig } from "@/utils/wallet";
import { useCardList } from "@/api/request";
import LoadingUI from "@/compoments/loadingUI";
import BankCard from "./bankCard";
import EmptyCard from "./emptyCard";
import CryptoCard from "./cryptoCard";
import DefaultCard from "./defaultCard";
import HuiwangCard from "./huiwangCard";
import SelectPlus from "@/wmCompoments/select";
import Icon from "@/wmCompoments/Icon";
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useModal } from "@/modals/modalContext";
import { useTranslation } from "react-i18next";

const RenderCard = React.memo((props: any) => {
    const { data, type } = props
    const localConfig = getWalletLocalConfig(type);
    switch (type) {
        case CardType.Bank:
            return <BankCard data={data} />
        case CardType.USDT:
            return <CryptoCard data={data} />
        case CardType.Huiwangpay:
            return <HuiwangCard data={data} />
        default:
            return <DefaultCard data={data} code={localConfig?.code}/>
    }
})
const Account = () => {
    const query = ut.getQueryParams();
    const { t } = useTranslation('accountManagement')
    const { t: tCard } = useTranslation('addCard')
    const [type, setType] = useState(query?.type ?? CardType.Bank)

    const localConfig = getWalletLocalConfig(type);
    const { data, isLoading } = useCardList(localConfig?.api)

 

    const allowAdd = (data?.length ?? 0) < (localConfig?.limit ?? 0)

    const { openModal } = useModal()


    const navigate = (type) => {
        const url = ut.buildUpdatedUrl(
            {
                type: type
            }
        )
        window.history.replaceState({}, '', url);
        setType(type)
    }

    const options = useMemo(() => {
        return BankCardList?.map((v) => {
            return {
                ...v,
                label: tCard(v.zhName),
                value: v.type
            }
        }) ?? []
    }, [BankCardList])

    return <div className={styles.warpper}>
        <div className={styles.titleWarpper}>
            <div>
                {tCard(localConfig?.zhName ?? '')}{t('addressManagement')}
            </div>
            <div className={styles.selectWarpper} >
                <SelectPlus
                    options={options}
                    value={type}
                    onChange={(v, o) => {
                        navigate(v)
                    }}
                    optionRender={(opt, selected) => (
                        <div className={styles.optionRender}>
                           <span>{opt.label}</span> 
                           {selected && <SpriteContainer name="icon_checked"/>}
                        </div>
                    )}
                    labelRender={(opt) => (
                        <div className={styles.labelRender}>
                            <span>{opt?.label}</span>
                         <Icon name={'icon-general-arrow-line-right'}/>
                        </div>
                    )}
                    
                    listHeight={200}
                    className={styles.select}
                />
            </div>
        </div>
        <LoadingUI loading={isLoading} height={300} data={[1]}>
            <div>
                <span>{t('currentWalletAdded')}</span>
                <span>{data?.length ?? 0}个</span>
                <span>{t('maxAddLimit', {
                    limit: localConfig?.limit
                })}</span>
            </div>
            {
                <div className={styles.list}>
                    {
                        data?.map((v) => {
                            return <RenderCard key={v.id} data={v} type={type}/>
                        })
                    }
                    {
                        allowAdd && <EmptyCard name={localConfig?.zhName ?? ''} onClick={()=>{
                            openModal('addCard',{
                                type: localConfig?.code ?? ''
                            })
                        }}/>
                    }
                </div>
            }
        </LoadingUI>
    </div>
}


export default Account

